import React from "react";
import { useAuth } from "../../auth/AuthContext";
import { UserType } from "../../models/base/UserType";
import { useNavigate, useLocation } from "react-router-dom";
import { validateEmail } from "../../utils/validators";
import Loader from "../shared/Loader";

const LoginPage: React.FC = () => {

    const [email, setEmail] = React.useState<string>("");
    const [emailError, setEmailError] = React.useState<string | null>(null);
    const [password, setPassword] = React.useState<string>("");

    const { login, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        setEmailError(validateEmail(email));

        if (emailError) {
            return;
        }

        const userType = await login(email, password);
        if (userType === null) {
            return;
        }

        if (userType === UserType.SuperAdmin) {
            navigate("/sa-settings/dashboard");
        } else if (userType === UserType.Admin) {
            navigate("/select-local");
        } else if (userType === UserType.LocalWorker) {
            navigate(`/worker-select-local`);
        } else if (userType === UserType.Client) {
            // Proveri da li postoji "from" u location state
            const from = (location.state as any)?.from;

            if (from && typeof from === 'string' && from.includes('/client-menu/')) {
                navigate(from);
            } else {
                navigate('/');
            }
        } else {
            navigate("/");
        }
    }

    return (
        <section className="login-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="login-wrapper">
                    <div className="login-form w-form">
                        <div className="text-block-26">Login</div>
                        <form className="form-6" onSubmit={handleSubmit}>

                            <label className="login-label">Email</label>
                            <input className="login-input w-input" placeholder="Enter email" type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            {emailError && <div className="error-text" style={{ marginTop: "-10px", marginBottom: "10px" }}>{emailError}</div>}

                            <label className="login-label">Password</label>
                            <input className="login-input w-input" placeholder="Enter password" type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div className="text-block-45" onClick={() => navigate("/forgot-password")}>Zaboravljena lozinka?</div>

                            {loading ?
                                <Loader fullscreen={false} color="white" />
                                :
                                <input type="submit" className="login-button w-button" value="Login" />}
                        </form>
                        <div className="div-block-84">
                            <div>Nemate nalog?</div>
                            <div className="link-text align-center" onClick={() => navigate("/register")}>Registruj se</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default LoginPage;
